import { required } from "@homebound/form-state";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import {
  BaseChangeEventFormInput,
  baseChangeEventFormConfig,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { SelectOptionStep } from "src/routes/projects/change-events/guided/workflows/addOrModifyOptions/1.SelectOptionStep";
import {
  reviewImpactStep,
  reviewStep,
} from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { useGuidedChangeEventActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useGuidedChangeEventActions";
import { useMaybeOpenCommitmentCleanupModal } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useMaybeOpenCommitmentCleanupModal";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

// Form shape for the Add/Modify Options workflow.
export type AddOrModifyOptionsFormInput = BaseChangeEventFormInput & { selectedOptionId?: string | null };

export const addOrModifyOptionsWorkflow = defineWorkflow<AddOrModifyOptionsFormInput>({
  workflow: ChangeEventWorkflow.AddOrModifyOptions,
  formConfig: { ...baseChangeEventFormConfig, selectedOptionId: { type: "value", rules: [required] } },
  steps: [
    {
      value: GuidedChangeEventStep.SelectOption,
      label: "Select Option",
      isComplete: (form) => !!form.selectedOptionId.value,
      render: (form) => <SelectOptionStep formState={form} />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: (args) => {
    const { saveChangeEvent } = useGuidedChangeEventActions(args);
    // Adding an option can rewrite scope that's already on a purchase order, and the backend won't touch a live PO,
    // so submitting is gated on those being cleaned up by hand first.
    const { submitWithCommitmentCleanup } = useMaybeOpenCommitmentCleanupModal({
      form: args.form,
      // TODO: submit the change event for the add-or-modify-options flow.
      onSubmit: async () => {},
      onSaveDraftAndExit: () => saveChangeEvent({ andExit: true }),
    });
    return { onSubmit: submitWithCommitmentCleanup };
  },
});
